import { IInventoryAdvancePaymentState } from '@/store/inventory-advance-payment';
import {
  IInventoryAdvancePaymentMutations,
  IRemoveInventoryAdvancePaymentAttachmentPayload
} from './mutations.types';
import {
  IUserData,
  IInventoryAdvancePaymentData,
  IMentionAttachmentCommentData
} from '@/models';
import { Transition } from '@/models/transition';

export const mutations: IInventoryAdvancePaymentMutations = {
  SET_COUNT(state: IInventoryAdvancePaymentState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IInventoryAdvancePaymentState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IInventoryAdvancePaymentState): void {
    state.count -= 1;
  },

  SET_INVENTORY_ADVANCE_PAYMENTS(
    state: IInventoryAdvancePaymentState,
    payload: IInventoryAdvancePaymentData[]
  ): void {
    state.inventoryAdvancePayments = payload;
  },

  ADD_INVENTORY_ADVANCE_PAYMENT(
    state: IInventoryAdvancePaymentState,
    payload: IInventoryAdvancePaymentData
  ): void {
    state.inventoryAdvancePayments.unshift(payload);
  },

  UPDATE_INVENTORY_ADVANCE_PAYMENT(
    state: IInventoryAdvancePaymentState,
    payload: IInventoryAdvancePaymentData
  ): void {
    const index = state.inventoryAdvancePayments.findIndex(
      (inventoryAdvancePayment: IInventoryAdvancePaymentData) =>
        inventoryAdvancePayment.id === payload.id
    );

    state.inventoryAdvancePayments.splice(index, 1, payload);
  },

  REMOVE_INVENTORY_ADVANCE_PAYMENT(
    state: IInventoryAdvancePaymentState,
    payload: number
  ): void {
    const index = state.inventoryAdvancePayments.findIndex(
      (inventoryAdvancePayment: IInventoryAdvancePaymentData) =>
        inventoryAdvancePayment.id === payload
    );

    state.inventoryAdvancePayments.splice(index, 1);
  },

  SET_INVENTORY_ADVANCE_PAYMENT_CURRENT_ASSIGNEES(
    state: IInventoryAdvancePaymentState,
    payload: IUserData[]
  ): void {
    state.currentAssignees = payload;
  },

  SET_INVENTORY_ADVANCE_PAYMENT_FINANCE_MANAGERS(
    state: IInventoryAdvancePaymentState,
    payload: IUserData[]
  ): void {
    state.financeManagers = payload;
  },

  SET_INVENTORY_ADVANCE_PAYMENT_APPROVERS(
    state: IInventoryAdvancePaymentState,
    payload: IUserData[]
  ): void {
    state.approvers = payload;
  },

  SET_INVENTORY_ADVANCE_PAYMENT_AP_SPECIALISTS(
    state: IInventoryAdvancePaymentState,
    payload: IUserData[]
  ): void {
    state.apSpecialists = payload;
  },

  SET_INVENTORY_ADVANCE_PAYMENT_ACTIVITIES(
    state: IInventoryAdvancePaymentState,
    payload: Transition[]
  ): void {
    state.activities = payload;
  },

  SET_INVENTORY_ADVANCE_PAYMENT_COMMENTS(
    state: IInventoryAdvancePaymentState,
    payload: IMentionAttachmentCommentData[]
  ): void {
    state.comments = payload;
  },

  ADD_INVENTORY_ADVANCE_PAYMENT_COMMENT(
    state: IInventoryAdvancePaymentState,
    payload: IMentionAttachmentCommentData
  ): void {
    state.comments.unshift(payload);
  },

  UPDATE_INVENTORY_ADVANCE_PAYMENT_COMMENT(
    state: IInventoryAdvancePaymentState,
    payload: IMentionAttachmentCommentData
  ): void {
    const index = state.comments.findIndex(
      (comment: IMentionAttachmentCommentData) => comment.id === payload.id
    );

    state.comments.splice(index, 1, payload);
  },

  REMOVE_INVENTORY_ADVANCE_PAYMENT_COMMENT(
    state: IInventoryAdvancePaymentState,
    payload: number
  ): void {
    const index = state.comments.findIndex(
      (comment: IMentionAttachmentCommentData) => comment.id === payload
    );

    state.comments.splice(index, 1);
  },

  SET_LAST_CREATED_INVENTORY_ADVANCE_PAYMENT_COMMENT_ID(
    state: IInventoryAdvancePaymentState,
    payload: number
  ): void {
    state.lastCreatedInventoryAdvancePaymentCommentId = payload;
  },

  SET_MENTIONABLE_USERS(
    state: IInventoryAdvancePaymentState,
    payload: IUserData[]
  ): void {
    state.mentionableUsers = payload;
  },

  REMOVE_INVENTORY_ADVANCE_PAYMENT_ATTACHMENT(
    state: IInventoryAdvancePaymentState,
    payload: IRemoveInventoryAdvancePaymentAttachmentPayload
  ): void {
    const inventoryAdvancePaymentIndex = state.inventoryAdvancePayments.findIndex(
      (v: IInventoryAdvancePaymentData) => v.id === payload.id
    );

    const foundInventoryAdvancePayment =
      state.inventoryAdvancePayments[inventoryAdvancePaymentIndex];
    if (foundInventoryAdvancePayment) {
      const attachmentIndex = foundInventoryAdvancePayment.attachments!.findIndex(
        v => v.id === payload.attachment
      );

      state.inventoryAdvancePayments[
        inventoryAdvancePaymentIndex
      ].attachments!.splice(attachmentIndex, 1);
    }
  },

  SET_LAST_PROMISE(
    state: IInventoryAdvancePaymentState,
    payload: Promise<any>
  ): void {
    state.lastPromise = payload;
  }
};
